<template>
  <div class="mt-1">
    <b-card>
      <b-overlay :show="loading" rounded="sm" no-fade>
        <div class="d-flex align-items-center justify-content-between mb-1">
          <h3 class="mb-0">Session Attendance</h3>
          <div>
            <b-button size="sm" variant="success" class="mr-50" @click="exportAttendance">Export Excel</b-button>
            <b-button size="sm" variant="outline-secondary" :to="{ name: 'dashboard' }">Back to Events</b-button>
          </div>
        </div>
         <!-- v-if="$Can ? $Can('manage_event_attendance') : true" -->
  <div v-if="canManageAttendance()" class="add-record border rounded p-1 mb-1">
          <div class="d-flex align-items-end flex-wrap">
            <div class="mr-1 mb-50" style="min-width:260px;">
              <label class="text-muted small mb-25 d-block">User</label>
              <v-select :options="userOptions" label="title" :reduce="u=>u.id" v-model="form.user_id" :clearable="true"/>
            </div>
            <div class="mr-1 mb-50" style="min-width:180px;">
              <label class="text-muted small mb-25 d-block">Status</label>
              <v-select :options="statusOptions" v-model="form.status" :reduce="v=>v"/>
            </div>
            <div class="flex-grow-1 mr-1 mb-50">
              <label class="text-muted small mb-25 d-block">Notes</label>
              <b-form-input v-model="form.notes"/>
            </div>
            <div class="mb-50">
              <b-button :disabled="!form.user_id || !form.status" variant="primary" @click="add">Add</b-button>
            </div>
          </div>
        </div>

        <b-table :items="records" :fields="tableFields" small bordered responsive="sm" show-empty empty-text="No attendance records">
          <template #cell(user)="{ item }">{{ (item.user && item.user.name) || '' }} {{ (item.user && item.user.surname) || '' }}</template>
          <template #cell(status)="{ item }">
            <v-select :options="statusOptions" v-model="item.status" :reduce="v=>v" @input="save(item)" :disabled="!canManageAttendance()"/>
          </template>
          <template #cell(recorded_at)="{ item }">{{ item.recorded_at ? dateFormat(item.recorded_at) : '-' }}</template>
          <template #cell(notes)="{ item }">
            <b-form-input v-model="item.notes" @change="save(item)" :disabled="!canManageAttendance()"/>
          </template>
          <template #cell(actions)="{ item }">
            <b-button v-if="canManageAttendance()" size="sm" variant="outline-danger" @click="remove(item)">Delete</b-button>
          </template>
        </b-table>
      </b-overlay>
    </b-card>
  </div>
</template>
<script>
import { BOverlay, BCard, BTable, BButton, BFormInput } from 'bootstrap-vue';
import vSelect from 'vue-select';
import store from '@/store';
import eventsStoreModule from './eventsStoreModule';
import { onUnmounted } from '@vue/composition-api';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
import moment from 'moment';

export default {
  components:{ BOverlay, BCard, BTable, BButton, BFormInput, vSelect, ToastificationContent },
  data(){ return { loading:false, records:[], statusOptions:['present','absent'], userOptions:[], form:{ user_id:null, status:'present', notes:'' }, eventAdmins:[] }; },
  setup(){ const MODULE='events'; if(!store.hasModule(MODULE)) store.registerModule(MODULE, eventsStoreModule); onUnmounted(()=>{ if(store.hasModule(MODULE)) store.unregisterModule(MODULE);}); },
  created(){ this.load(); this.loadOptions(); this.loadEventAdmins(); },
  computed:{
    tableFields(){
      const base = [
        { key:'user', label:'User' },
        { key:'status', label:'Status' },
        { key:'notes', label:'Notes' },
        { key:'recorded_at', label:'Recorded' },
      ];
      if(this.canManageAttendance()) base.push({ key:'actions', label:'Actions' });
      return base;
    },
  },
  methods:{
  canManageAttendance(){ return this.$CanEvent ? this.$CanEvent('manage_event_attendance', this.eventAdmins) : (this.$Can ? this.$Can('manage_event_attendance') : true); },
    async loadEventAdmins(){
      try{
        const sessionId = this.$route.params.sessionId;
        if(!sessionId) { this.eventAdmins = []; return; }
        const sRes = await store.dispatch('events/getSessionById', { sessionId });
        const session = (sRes && sRes.data) || {};
        let admins = [];
        const eventId = session.event_id || (session.event && session.event.id);
        if(eventId){
          const eRes = await store.dispatch('events/getEventById', { id: eventId });
          const ev = (eRes && eRes.data) || {};
          admins = ev.admins || [];
        } else if(session.event && session.event.admins){
          admins = session.event.admins;
        }
        this.eventAdmins = admins;
      } catch(e){
        this.eventAdmins = [];
      }
    },
    dateFormat(val){ return moment(String(val)).format('DD-MM-YYYY HH:mm'); },
    async load(){ try{ this.loading=true; const sessionId=this.$route.params.sessionId; const res = await store.dispatch('events/listAttendanceBySession', { sessionId }); this.records = res.data; } catch(e){ this.$toast({ component: ToastificationContent, props:{ title:'Failed to load attendance', icon:'AlertTriangleIcon', variant:'danger' } }); } finally{ this.loading=false; } },
    async loadOptions(){ try{ const res = await store.dispatch('events/fetchEventOptions'); const opts = res.data || {}; this.userOptions = (opts.users || []).map(u=>({ id:u.id, title: (u.title || (u.name? (u.name + (u.surname? (' ' + u.surname) : '')) : 'User #' + u.id)) })); } catch(e){} },
    async save(item){ try{ await store.dispatch('events/updateAttendanceRecord', { recordId: item.id, data: { status: item.status, notes: item.notes } }); this.$toast({ component: ToastificationContent, props:{ title:'Saved', icon:'ThumbsUpIcon', variant:'success' } }); } catch(e){ this.$toast({ component: ToastificationContent, props:{ title:'Save failed', icon:'AlertTriangleIcon', variant:'danger' } }); } },
    async exportAttendance(){
      try{
        const sessionId = this.$route.params.sessionId;
        const res = await store.dispatch('events/exportAttendanceBySession', { sessionId });
        this.downloadBlob(res);
      } catch(e){
        this.$toast({ component: ToastificationContent, props:{ title:'Export failed', icon:'AlertTriangleIcon', variant:'danger' } });
      }
    },
    downloadBlob(res){
      const disposition = res.headers && (res.headers['content-disposition'] || res.headers['Content-Disposition']);
      const match = disposition && disposition.match(/filename="?([^";]+)"?/);
      const filename = match ? match[1] : 'attendance.xlsx';
      const blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url; a.download = filename; document.body.appendChild(a); a.click(); a.remove();
      window.URL.revokeObjectURL(url);
    },
    async add(){
      try{
        if(!this.form.user_id || !this.form.status) return;
        const sessionId=this.$route.params.sessionId;
        const payload = { user_id:this.form.user_id, status:this.form.status, notes: this.form.notes || null };
        await store.dispatch('events/addAttendanceRecord', { sessionId, data: payload });
        await this.load();
        this.form.notes='';
        this.$toast({ component: ToastificationContent, props:{ title:'Added', icon:'CheckIcon', variant:'success' } });
      } catch(e){
        this.$toast({ component: ToastificationContent, props:{ title:'Add failed', icon:'AlertTriangleIcon', variant:'danger' } });
      }
    },
    async remove(item){ const ok = await this.$bvModal.msgBoxConfirm('Delete record?', { size:'sm', title:'Confirm', okVariant:'primary', okTitle:'Yes', cancelTitle:'No', cancelVariant:'outline-secondary', centered:true }); if(!ok) return; await store.dispatch('events/deleteAttendanceRecord', { recordId:item.id }); this.records = this.records.filter(r=>r.id!==item.id); },
  }
}
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
